import { useCallback, useEffect, useState } from "react";
import { getStaffName } from "../../services/customerTouchPoint";

const useStaffName = () => {
  const [data, setData] = useState([]);

  const fetchData = useCallback(async () => {
    const res = await getStaffName();
    let newValue = [];
    if (res.data.code === "0000") {
      const { objectValue } = res.data;
      objectValue.map((item) => {
        newValue.push({
          id: item.staffUniqueId,
          value: item.fullName,
          staffName: item.staffName,
          staffLastname: item.staffLastname,
          position: item?.positionTh || "",
        });
      });
      setData(newValue);
    }
  }, [setData]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  return [data];
};

export default useStaffName;
